import RegionList from './RegionList'
import RegionEdit from './RegionEdit'

const RegionConfig = {
    list: RegionList,
    edit: RegionEdit,
    options: {
        label: 'Region',
        items: true
    }
};

export default RegionConfig